import React, { createContext, useState } from "react";
import { ObjectElaborationSelector } from "../generic/ObjectElaborationSelector";
import { ElaborationStatusItem } from "../../redux/feature/object/remote-elaborations-slice";
import { ObjectPanel } from "./object-panel/ObjectPanel";
import { OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION } from "../../utils/constants/notification";
import { CoObjectItem } from "../interfaces/CoObject";
import { ElaborationWrapper } from "./ElaborationWrapper";

export interface ObjectPanelElaborationWrapperProps {
  isEdit: boolean;
  coObject: CoObjectItem;
}

export interface CoObjectContextWrapper {
  coObject: CoObjectItem;
  update: (coObject: CoObjectItem) => void;
}

export const CoObjectContext = createContext<CoObjectContextWrapper | null>(null);

export const ObjectPanelElaborationWrapper: React.FunctionComponent<ObjectPanelElaborationWrapperProps> = (props) => {
  const [coObject, setCoObject] = useState<CoObjectItem>(props.coObject);
  return (
    <CoObjectContext.Provider value={{ coObject: coObject, update: (newCoObject) => setCoObject(newCoObject) }}>
      <ObjectElaborationSelector coObject={coObject}>
        {(_, elaborationItem) => (
          <ObjectPanelWithElaboration coObject={coObject} isEdit={props.isEdit} elaborationItem={elaborationItem} />
        )}
      </ObjectElaborationSelector>
    </CoObjectContext.Provider>
  );
};

interface ObjectPanelWithElaborationProps {
  isEdit: boolean;
  typeElaboration?: string;
  coObject: CoObjectItem;
  elaborationItem?: ElaborationStatusItem;
}

export const ObjectPanelWithElaboration: React.FunctionComponent<ObjectPanelWithElaborationProps> = (props) => {
  const { elaborationItem, coObject } = props;
  const notificationKey = `${OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION}-${coObject.contentControlId}`;

  return (
    <>
      <ElaborationWrapper elaborationItem={elaborationItem} notificationKey={notificationKey}>
        <ObjectPanel coObject={props.coObject} isEdit={props.isEdit} />
      </ElaborationWrapper>
    </>
  );
};
